import React from "react";
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  Button,
  Alert,
  InputGroupAddon,
  InputGroup
} from "reactstrap";

import propTypes from "prop-types";
import styled from "styled-components";
import { convertToRupiah, normalizeBrand } from "../../utils/Helpers";
import { TextRupiah } from "../Text";
import {
  ADMINISTRATOR,
  APPROVED,
  SUSPEND,
  REJECTED,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  CANCELLED,
  DRAFT,
  MORE_INFO,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  LISTING,
  emptyImage
} from "../../utils";
import ReactLoading from "react-loading";
import { getCacheImage } from "../../config";
import _ from "lodash";

import NotesSelling from "../PageUserDashboard/Sections/Table/NotesSelling";
import CloseIcon from "../../images/close-button-search.png";
import Loading from "../../components/Loading";
import { getCloudImageUrl } from "../../utils";

const disabledButton = highest_bid => {
  if (highest_bid === null) {
    return true;
  } else {
    return false;
  }
};

const defectCondition = (bool, condition, defects, size) => {
  switch (bool) {
    case true:
      return detailCondition(condition, size, defects);
    case false:
      return (
        <ButtonWrapper>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            US {size}{" "}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            {infoString(condition)}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            Perfect Condition
          </Button>
        </ButtonWrapper>
      );

    default:
      return (
        <ButtonWrapper>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            US {size}{" "}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            {infoString(condition)}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            Perfect Condition
          </Button>
        </ButtonWrapper>
      );
  }
};

const detailCondition = (condition, size, defects) => {
  const conditions = defects.filter(item => item.value);

  return (
    <ButtonWrapper>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        US {size}{" "}
      </Button>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        {infoString(condition)}
      </Button>
      {conditions.map((data, index) => {
        return (
          <Button
            key={index}
            className="btn-black flat"
            style={{ cursor: "default" }}
          >
            {data.display_name}
          </Button>
        );
      })}
    </ButtonWrapper>
  );
};

const sneakerCondition = condition => {
  switch (condition) {
    case "BARU":
      return "Brand New";
    case "BEKAS":
      return "Used";
    case "PRISTINE":
      return "Pristine";
    case "GOOD":
      return "Good";
    case "WELL_USED":
      return "Well Used";
    case "LIKE_NEW":
      return "Like New";
    case "VINTAGE":
      return "Vintage";
    default:
      return "Brand New";
  }
};

const handbagCondition = data => {
  return detailHandbagCondition(data);
};

const detailHandbagCondition = data => {
  const condition = data
    .filter(item => item.value)
    .map(item => item.display_name)
    .join(" / ");

  return condition;
};

const accessories = condition => {
  if (condition === true) {
    return "Missing Accessories";
  } else {
    return "Complete Accessories";
  }
};

const boxHandbag = value => {
  if (value === true) {
    return "";
  } else {
    return "Missing Box";
  }
};

const dustBag = value => {
  if (value === true) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

const ModalEditSellPriceV2 = props => {
  const {
    product_variant: {
      display_name,
      product,
      product_variant_images,
      SKU,
      slug,
      hide_box_info,
      vintage: isVintage
    },
    product_variant_id,
    size,
    sneakers_condition,
    box_condition,
    missing_accessories,
    asking_price,
    highest_bid,
    lowest_ask,
    id,
    sneakers_defect,
    defects,
    status
  } = props.onData;

  const uniqueDefects = props.onData === null ? [] : _.uniqBy(defects, "name");
  const dustBagCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "DUST_BAG")
    : {};
  const boxCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "BOX")
    : {};
  const categoryUrl =
    product.category.name === "apparels" || product.category.name === "Apparels"
      ? "apparel"
      : product.category.name === "handbags"
      ? "luxury"
      : product.category.name;
  const onErrorImg = e => {
    e.target.src = emptyImage(product.category.name);
  };
  const luxuryDetailArr = [
    sneakerCondition(sneakers_condition),
    accessories(missing_accessories),
    dustBag(dustBagCondition),
    hide_box_info ? "" : boxHandbag(boxCondition),
    sneakers_defect ? handbagCondition(uniqueDefects) : ""
  ];
  const luxuryDetail = luxuryDetailArr
    .filter(item => item !== "" && item !== "Missing Box")
    .map(item => item)
    .join(" / ");

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.onToggle}
      className="kick-modal detail-selling"
    >
      <Container id="payment">
        <ModalHeader id="header-detail-sell">
          <div onClick={props.onToggle}>
            <KickImage src={CloseIcon} alt="close-icon" />
          </div>
        </ModalHeader>
        {props.underReservation ? (
          <div style={{ textAlign: "center" }}>
            <span style={{ color: "red" }}>UNDER RESERVATION</span>
          </div>
        ) : null}
        <ModalBody>
          <Row>
            <Col>
              <div className="wrapper-image">
                <KickImage
                  src={
                    product_variant_images && product_variant_images.length
                      ? getCloudImageUrl(product_variant_images[0].URL, 400)
                      : emptyImage(product.category.name)
                  }
                  alt={display_name}
                  onError={e => onErrorImg(e)}
                />
              </div>
              <div className="wrapper-image title">
                <span>{product.brand? (product.category.name === "lifestyles"? normalizeBrand(product.brand.name) : normalizeBrand(product.brand.flat[0])) : ""}</span>
                <span
                  onClick={() =>
                    props.history.push(
                      `/${categoryUrl}/${product_variant_id}/${slug}`
                    )
                  }
                >
                  {display_name}
                </span>
                <span>{SKU}</span>
              </div>
            </Col>
          </Row>
            {isVintage?
              <Row>
                <ButtonWrapper isVintage={true}>
                  <Button
                      className="btn-black flat"
                      style={{ cursor: "default" }}
                    >
                      US {size && size.US}
                  </Button>
                  <Button
                      className="btn-black flat"
                      style={{ cursor: "default" }}
                    >
                      Vintage
                  </Button>
                </ButtonWrapper>
              </Row>
              :
              <Row>
                {product.category.name === "handbags" ? (
                  <div style={{ textAlign: "center" }}>
                    <span>{luxuryDetail}</span>
                  </div>
                ) : product.category.name === "sneakers" ? (
                  <ButtonWrapper hide_box_info={hide_box_info}>
                    <Button
                      className="btn-black flat"
                      style={{ cursor: "default" }}
                    >
                      US {size && size.US}
                    </Button>
                    <Button
                      className="btn-black flat"
                      style={{ cursor: "default" }}
                    >
                      {infoString(sneakers_condition)}
                    </Button>
                    {!hide_box_info && (
                      <Button
                        className="btn-black flat"
                        style={{ cursor: "default" }}
                      >
                        {infoString(box_condition)}
                      </Button>
                    )}
                    <Button
                      className="btn-black flat"
                      style={{ cursor: "default" }}
                    >
                      {infoString(missing_accessories)}
                    </Button>
                  </ButtonWrapper>
                ) : (
                  defectCondition(
                    sneakers_defect,
                    sneakers_condition,
                    defects,
                    size && size.US
                  )
                )}
              </Row>
            }
          <Row>
            <Col>
              <Form onSubmit={e => e.preventDefault()}>
                <Label>Selling Price</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">RP.</InputGroupAddon>
                  <Input
                    name="price-sell"
                    value={convertToRupiah(parseInt(asking_price))}
                    onChange={props.onChangePrice}
                    disabled={props.underReservation === true}
                    onKeyPress={props.onKeyPress}
                    onBlur={props.onBlur}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>{props.sellingPriceError}</span>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col xs={6} className="price-section">
              <div className="wrapper-price">
                <span>Lowest Price (Buy Now)</span>
                <span>
                  {lowest_ask == 0.0 ? (
                    "-"
                  ) : (
                    <TextRupiah
                      prefix="RP. "
                      value={lowest_ask}
                      color="black"
                    />
                  )}
                </span>
              </div>
            </Col>
            <Col xs={3} className="price-section">
              <div className="wrapper-price">
                <span>Highest Offer</span>
                <span>
                  {highest_bid ? (
                    <TextRupiah
                      prefix="RP. "
                      value={highest_bid.amount}
                      color="black"
                    />
                  ) : (
                    "-"
                  )}
                </span>
              </div>
            </Col>
            <Col xs={3} className="price-section button-sell">
              {props.isSubmitOffer ? (
                <Loading center height={30} width={30} />
              ) : (
                <Button
                  className="btn-white flat"
                  type="button"
                  disabled={disabledButton(highest_bid) || props.underReservation}
                  onClick={() => props.openAlert(id, highest_bid.id)}
                >
                  SELL NOW
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <NotesSelling />
            </Col>
          </Row>
          <Row>
            <Col>
              {props.isProcessSubmit ? (
                <Loading center />
              ) : (
                <Button
                  className="btn-green flat"
                  disabled={
                    props.isProcessSubmit ||
                    props.underReservation === true ||
                    !props.priceChange
                  }
                  onClick={() => props.onSubmit("submit")}
                >
                  SAVE CHANGES
                </Button>
              )}
            </Col>
          </Row>
          {props.underReservation ? null : (
            <Row>
              <Col>
                <span onClick={() => props.onDeleteListing(id)}>
                  Delete This Listing
                </span>
              </Col>
            </Row>
          )}
        </ModalBody>
      </Container>
    </Modal>
  );
};

const infoString = data => {
  switch (data) {
    case SEMPURNA[0]:
      return SEMPURNA[2];
    case CACAT[0]:
      return CACAT[1];
    case NO_BOX[0]:
      return NO_BOX[1];
    case BARU[0]:
      return BARU[2];
    case BEKAS[0]:
      return BEKAS[2];
    case APPROVED:
      return LISTING[0];
    case SUSPEND:
      return LISTING[1];
    case DRAFT[0]:
      return DRAFT[1];
    case MORE_INFO[0]:
      return MORE_INFO[1];
    case CANCELLED[0]:
      return CANCELLED[1];
    case WAIT_CONFIRM[0]:
      return WAIT_CONFIRM[1];
    case WAIT_CONSIGN[0]:
      return WAIT_CONSIGN[1];
    case UNDER_REVIEW[0]:
      return UNDER_REVIEW[1];
    case REJECTED[0]:
      return REJECTED[1];
    case false:
      return "Complete Accessories";
    case true:
      return "Missing Accessories";
    default:
      return ADMINISTRATOR;
  }
};

const ButtonWrapper = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: ${props =>
    props.hide_box_info ? "1fr 1fr 1fr" : props.isVintage? "1fr 1fr" : "1fr 1fr 1fr 1fr"};
  grid-column-gap: 0.5rem;
`;

ModalEditSellPriceV2.propTypes = {
  imagesVariant: propTypes.array,
  onData: propTypes.object
};

ModalEditSellPriceV2.defaultProps = {
  imagesVariant: Array.from(Array(7).keys())
};

export default ModalEditSellPriceV2;
